export const VIEW_ALERTS_LOADER: string = 'view-alerts-loader';
export const INTENT_SETTING_MODAL_LOADING_TAG: string = 'intent-settings-loader';